import { withUnmountTransition } from '../../../../misc/withUnmountTransition.hoc'
import { MailClassificationModal } from './MailClassificationModal.component'

const withUnmountHoc = withUnmountTransition(MailClassificationModal)
export { withUnmountHoc as MailClassificationModal }
